import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { Container } from "react-bootstrap";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import {
  getLedgerWallet,
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletExtensionWallet,
  getSolletWallet,
  getTorusWallet,
} from "@solana/wallet-adapter-wallets";
import { useWallet } from "@solana/wallet-adapter-react";
// import { clusterApiUrl } from "@solana/web3.js";
import { useCallback, useMemo } from "react";
import toast, { Toaster } from "react-hot-toast";
import RaffleHome from "containers/RaffleHome";
import RaffleDetails from "containers/RaffleDetails";
import styled from "styled-components";


import {
  Switch,
  Route,
  Link,
} from "react-router-dom";
import GetWinners from "containers/GetWinners";

const App = () => {
  const { publicKey } = useWallet();
  // Can be set to 'devnet', 'testnet', or 'mainnet-beta'
  // const network = WalletAdapterNetwork.Devnet;
  const network = WalletAdapterNetwork.Mainnet;
  // const network = process.env.REACT_APP_RPC_ID
  // You can also provide a custom RPC endpoint
  const endpoint = process.env.REACT_APP_RPC_ID
  // const endpoint =
  //   "https://cold-small-meadow.solana-mainnet.quiknode.pro/4d5ba9470c46ab34821fae34c32664c71ca5c40f/";
  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
  // Only the wallets you configure here will be compiled into your application, and only the dependencies
  // of wallets that your users connect to will be loaded
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getTorusWallet(),
      getLedgerWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [network]
  );

  const onError = useCallback(
    (error) => {
      toast.error(
        error.message ? `${error.name}: ${error.message}` : error.name, {
        duration: 3000
      });
    },
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} onError={onError} autoConnect>
        <WalletModalProvider>
          <Container>
            <PageWrapper>
              <TopContainer>
                <Link to="/" style={{ alignItems: "center", display: "flex" }}>
                  <h2>Cosmic Sentinels</h2>
                </Link>
                <div>
                  <WalletMultiButton
                    className={publicKey ? "wallet-multi active" : "wallet-multi"}
                  />
                </div>
              </TopContainer>
              <Switch>
                <Route exact path="/" component={RaffleHome} />
                <Route path="/raffle/:id" exact component={RaffleDetails} />
                <Route path="/entries/:id" exact component={GetWinners} />
              </Switch>
            </PageWrapper>
          </Container>
        </WalletModalProvider>
        <Toaster position="top-center" reverseOrder={false} />
      </WalletProvider>
    </ConnectionProvider>
  );
};


export default App

const PageWrapper = styled.div`
  min-height: 100vh;
  padding: 44px 0 100px;
  position: relative;
  z-index: 1;
`;

const TopContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  a,h3 {
    color:#fff!important;
    text-decoration: none;
  }

  .long-logo {
    display: none;

    @media only screen and (min-width: 768px) {
      display: flex;
    }
  }

  .small-logo {
    @media only screen and (min-width: 768px) {
      margin-right: 16px;
    }
  }
`;
